import { SUCCESS, FETCH_SCANNED_ATTENDEES, FETCH_ATTENDEE_NOTES, POST_ATTENDEE_NOTES, FETCH_ATTENDEE } from '../constants/actionApi';
import { UPDATE_FAV_MODEL } from '../constants/actionLocal';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';

export default (state = initialState.scannedAttendees, { type, payload }) => {
  switch (type) {
    case FETCH_SCANNED_ATTENDEES + SUCCESS:
    case FETCH_ATTENDEE_NOTES + SUCCESS:
    case POST_ATTENDEE_NOTES + SUCCESS:
    case FETCH_ATTENDEE + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    case UPDATE_FAV_MODEL:
      if (payload.type === 'attendee') {
        return addOrUpdateItemsInState(state, payload.data);
      } else {
        return state;
      }
    default:
      return state;
  }
};
